import config from '../config';

export interface StartAttachmentUploadResponse {
  fileId: string;
  uploadUrl: string;
  uploadHeaders?: Record<string, string>;
}

interface StartAttachmentUploadApiResponse {
  fileId: string;
  uploadUrl: string;
  uploadHeaders?: Record<string, string>;
  headersToInclude?: Record<string, string>;
}

export const startAttachmentUpload = async (contactId: string, file: File): Promise<StartAttachmentUploadResponse> => {
  const { emailApiUrl } = config;

  if (!emailApiUrl) {
    throw new Error('Email API Url is not configured');
  }

  const response = await fetch(`${emailApiUrl}/attachment/start`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json'
    },
    body: JSON.stringify({
      contactId,
      fileName: file.name,
      fileSizeInBytes: file.size
    })
  });

  if (!response.ok) {
    throw new Error(`API responded with status ${response.status}`);
  }

  const body = (await response.json()) as StartAttachmentUploadApiResponse;

  return {
    fileId: body.fileId,
    uploadUrl: body.uploadUrl,
    uploadHeaders: body.uploadHeaders ?? body.headersToInclude
  };
};

export type AttachmentScanStatus = 'approved' | 'rejected' | 'failed' | 'scanning';

export interface GetAttachmentStatusResponse {
  fileId: string;
  status: AttachmentScanStatus;
}

export const getAttachmentStatus = async (contactId: string, fileId: string): Promise<GetAttachmentStatusResponse> => {
  const { emailApiUrl } = config;

  if (!emailApiUrl) {
    throw new Error('Email API Url is not configured');
  }

  const url = new URL(`${emailApiUrl}/attachment/status`);
  url.searchParams.set('contactId', contactId);
  url.searchParams.set('fileId', fileId);

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: { accept: 'application/json' }
  });

  if (!response.ok) {
    throw new Error(`API responded with status ${response.status}`);
  }

  return (await response.json()) as GetAttachmentStatusResponse;
};

export const completeAttachmentUpload = async (contactId: string, fileId: string): Promise<void> => {
  const { emailApiUrl } = config;

  if (!emailApiUrl) {
    throw new Error('Email API Url is not configured');
  }

  const response = await fetch(`${emailApiUrl}/attachment/complete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ contactId, fileId })
  });

  if (!response.ok) {
    throw new Error(`API responded with status ${response.status}`);
  }
};
